import React from 'react';

const Main = () => {
    return (
        <div id='infraMain'>
            <div className="container mt-4">
                {/* PDF Files with Clickable Icons and Headings */}
                <div className="row pt-5">
                    <h2 className="my-heading">Infrastructure</h2>
                    {/* Image Section */}
                    <div className="col-md-6 mb-4">
                        {/* Anti Ragging Grievance Process Flow Chart Image */}
                        <img
                            src="assets\images\infra.jpg"
                            alt="Anti Ragging Grievance Process Flow Chart"
                            className="img-fluid"
                            style={{ width: 600, height: 391 }}
                        />
                    </div>
                    {/* PDF Files Section */}
                    <div className="col-md-6 mb-4">
                        {/* Heading for PDF Files */}
                        {/* <h2>Infrastructure</h2> */}
                        <br />
                        {/* PDF File Icons */}
                        <div className="row global-card-parent">
                            {/* Example PDF File 1 */}
                            <div
                                className="col-md-4 mb-4 global-card"
                                style={{
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    position: "relative"
                                }}
                            >
                                {/* <a href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/GENERAL_AMBIENCE.pdf" target="_blank"> */}
                                {/* <i className="fas fa-file-pdf fa-3x pdf-icon"></i> */}
                                <p style={{ position: "absolute", top: 40 }}>General Ambience</p>
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/GENERAL_AMBIENCE.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="normal-button"
                                    style={{ position: "absolute", bottom: 20 }}
                                >
                                    View More
                                </a>
                                {/* </a> */}
                            </div>
                            <div
                                className="col-md-4 mb-4 global-card"
                                style={{
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    position: "relative"
                                }}
                            >
                                {/* <i className="fas fa-file-pdf fa-3x pdf-icon"></i> */}
                                <p style={{ position: "absolute", top: 40 }}>
                                    Class room with ICT Facilities
                                </p>
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/infra_CLASS_ROOM.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="normal-button"
                                    style={{ position: "absolute", bottom: 20 }}
                                >
                                    View More
                                </a>
                            </div>
                            <div
                                className="col-md-4 mb-4 global-card"
                                style={{
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    position: "relative"
                                }}
                            >
                                {/* <i className="fas fa-file-pdf fa-3x pdf-icon"></i> */}
                                <p style={{ position: "absolute", top: 40 }}>Computer Center</p>
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/infra-Computer_Center.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="normal-button"
                                    style={{ position: "absolute", bottom: 20 }}
                                >
                                    View More
                                </a>
                            </div>
                            <div
                                className="col-md-4 mb-4 global-card"
                                style={{
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    position: "relative"
                                }}
                            >
                                {/* <i className="fas fa-file-pdf fa-3x pdf-icon"></i> */}
                                <p style={{ position: "absolute", top: 40 }}>Computer Labs</p>
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/COMPUTER_LAB.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="normal-button"
                                    style={{ position: "absolute", bottom: 20 }}
                                >
                                    View More
                                </a>
                            </div>
                            <div
                                className="col-md-4 mb-4 global-card"
                                style={{
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    position: "relative"
                                }}
                            >
                                {/* <i className="fas fa-file-pdf fa-3x pdf-icon"></i> */}
                                <p style={{ position: "absolute", top: 40 }}>Laboratories</p>
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/LABS.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="normal-button"
                                    style={{ position: "absolute", bottom: 20 }}
                                >
                                    View More
                                </a>
                            </div>
                            <div
                                className="col-md-4 mb-4 global-card"
                                style={{
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    position: "relative"
                                }}
                            >
                                {/* <i className="fas fa-file-pdf fa-3x pdf-icon"></i> */}
                                <p style={{ position: "absolute", top: 40 }}>
                                    Energy Conversation Facilities
                                </p>
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/ENERGY_CONSERVATION_7.1.2.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="normal-button"
                                    style={{ position: "absolute", bottom: 20 }}
                                >
                                    View More
                                </a>
                            </div>
                            <div
                                className="col-md-4 mb-4 global-card"
                                style={{
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    position: "relative"
                                }}
                            >
                                {/* <i className="fas fa-file-pdf fa-3x pdf-icon"></i> */}
                                <p style={{ position: "absolute", top: 40 }}>
                                    Waste Management Facilities
                                </p>
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Waste_Management_7.1.3.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="normal-button"
                                    style={{ position: "absolute", bottom: 20 }}
                                >
                                    View More
                                </a>
                            </div>
                            <div
                                className="col-md-4 mb-4 global-card"
                                style={{
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    position: "relative"
                                }}
                            >
                                {/* <i className="fas fa-file-pdf fa-3x pdf-icon"></i> */}
                                <p style={{ position: "absolute", top: 40 }}>
                                    Water Conservation Facilities
                                </p>
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Water_Consvertaion_%207.1.4.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="normal-button"
                                    style={{ position: "absolute", bottom: 20 }}
                                >
                                    View More
                                </a>
                            </div>
                            <div
                                className="col-md-4 mb-4 global-card"
                                style={{
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    position: "relative"
                                }}
                            >
                                {/* <i className="fas fa-file-pdf fa-3x pdf-icon"></i> */}
                                <p style={{ position: "absolute", top: 40 }}>
                                    Green Campus Initiatives
                                </p>
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/infra-green-campus.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="normal-button"
                                    style={{ position: "absolute", bottom: 20 }}
                                >
                                    View More
                                </a>
                            </div>
                            <div
                                className="col-md-4 mb-4 global-card"
                                style={{
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    position: "relative"
                                }}
                            >
                                {/* <i className="fas fa-file-pdf fa-3x pdf-icon"></i> */}
                                <p style={{ position: "absolute", top: 40 }}>
                                    Disabled Friendly Environment
                                </p>
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Disabled_Friendly_enviroment_7.1.7.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="normal-button"
                                    style={{ position: "absolute", bottom: 20 }}
                                >
                                    View More
                                </a>
                            </div>
                            <div
                                className="col-md-4 mb-4 global-card"
                                style={{
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    position: "relative"
                                }}
                            >
                                {/* <i className="fas fa-file-pdf fa-3x pdf-icon"></i> */}
                                <p style={{ position: "absolute", top: 40 }}>Gender Equity</p>
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/GENDER_EQUITY.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="normal-button"
                                    style={{ position: "absolute", bottom: 20 }}
                                >
                                    View More
                                </a>
                            </div>
                            <div
                                className="col-md-4 mb-4 global-card"
                                style={{
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    position: "relative"
                                }}
                            >
                                {/* <i className="fas fa-file-pdf fa-3x pdf-icon"></i> */}
                                <p style={{ position: "absolute", top: 40 }}>Sports</p>
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/SPORTS.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="normal-button"
                                    style={{ position: "absolute", bottom: 20 }}
                                >
                                    View More
                                </a>
                            </div>
                            {/* Repeat this block for other PDF files */}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;